import { Password } from "primereact/password";
import {
  POST,
  sGET,
  sGETLocal,
  sPOST,
  // srPOSTLocal,

} from "../protocol/HTTP";
import backendUrls from "../urls/backendUrls";


const UserService = {

  login: function (data, cbs, cbe) {
    const url = backendUrls.Authentication.login;
    console.log(url)
    POST(url, data, cbs, cbe);
  },

  getUsers: function (cbs, cbe) {
    const url = backendUrls.Users.users;
    console.log(url)
    sGET(url, cbs, cbe);
  },

  getDrivers: function (cbs, cbe) {
    const url = backendUrls.Drivers.drivers;
    console.log(url)
    sGET(url, cbs, cbe);
  },

  getBookings: function (cbs, cbe) {
    const url = backendUrls.Bookings.bookings;
    console.log(url)
    sGET(url, cbs, cbe);
  },
  getTimelines: function (cbs, cbe) {
    const url = backendUrls.Timelines.timelines;
    console.log(url)
    sGET(url, cbs, cbe);
  },

  getMessages: function (cbs, cbe) {
    const url = backendUrls.Messages.messages;
    console.log(url)
    sGET(url, cbs, cbe);
  },

  addMessage: function (data, cbs, cbe) {
    const url = backendUrls.Messages.add_message;
    console.log(url)
    sPOST(url, data, cbs, cbe);
  },

  verifierAccount: function (id, data, cbs, cbe) {
    const url = backendUrls.Authentication.verified + "/" + `${id}`;
    console.log(url)
    sPOST(url, data, cbs, cbe);
  },

  unVerifierAccount: function (id, data, cbs, cbe) {
    const url = backendUrls.Authentication.unVerified + "/" + `${id}`;
    console.log(url)
    sPOST(url, data, cbs, cbe);
  },

  addMessageUsers: function (data, cbs, cbe) {
    const url = backendUrls.Messages.add_message_user;
    console.log(url)
    sPOST(url, data, cbs, cbe);
  },


  getMessagesUsers: function (cbs, cbe) {
    const url = backendUrls.Messages.messages_users;
    console.log(url)
    sGET(url, cbs, cbe);
  },





  loginParent: function (data, cbs, cbe) {
    const url = backendUrls.Authentication.loginParent;

    POST(url, data, cbs, cbe);
  },



  registerParent: function (data, cbs, cbe) {
    const url = backendUrls.Authentication.registerParent;


  },

  getRelationship: function (cbs, cbe) {
    const url = backendUrls.Authentication.getRelationships;


  },

  getParentDetails: function (id, cbs, cbe) {
    const url = backendUrls.Authentication.getParentDetails + "/" + `${id}`;


  },

  getStats: function (cbs, cbe) {
    const url = backendUrls.Others.stats;


  },

  getCourses: function (cbs, cbe) {
    const url = backendUrls.Others.courses;


  },

  getStudents: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.students + "?branch_id=" + `${branch_id}&company_id=` + `${company_id}`;


  },

  getStudentsAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.students + "?company_id=" + `${company_id}`;


  },

  getStudentsCompany: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.studentsCompany + "?company_id=" + `${company_id}`;


  },



  getAcamdeyYear: function (cbs, cbe) {
    const url = backendUrls.Others.academyYear;


  },

  getAcamdeyYearByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.academyYear + "?branch_id=" + `${branch_id}&company_id=` + `${company_id}`;


  },

  getAcamdeyYearByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.academyYear + "?company_id=" + `${company_id}`;


  },


  getAcamdeyTermByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.academyTerm + "?branch_id=" + `${branch_id}&company_id=` + `${company_id}`;


  },

  getAcamdeyTermByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.academyTerm + "?company_id=" + `${company_id}`;


  },

  getFeesTermByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.fees +
      "?domain=[('operating_branch_id', '='," + `${branch_id}` + "),('company_id', '='," + `${company_id}` + ")]";


  },

  getFeesTermByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.fees +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";


  },


  getSessionSearch: function (course_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.sessionSearch +
      "?domain=[('course_id', '='," + `${course_id}` + "),('company_id', '='," + `${company_id}` + ")]";


  },


  getTimetableSearch: function (company_id, course_id, cbs, cbe) {
    const url = backendUrls.Others.timetableSearch + "?company_id=" + `${company_id}` + "&course_id=" + `${course_id}`;


  },

  getCourseByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.courses +
      "?domain=[('operating_branch_id', '='," + `${branch_id}` + "),('company_id', '='," + `${company_id}` + ")]";;


  },
  getCourseByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.courses +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";;


  },
  getCourseByBranchAndComapny2: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.courses +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";;


  },

  getBatchesByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.batches +
      "?domain=[('operating_branch_id', '='," + `${branch_id}` + "),('company_id', '='," + `${company_id}` + ")]";;


  },
  getBatchesByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.batches +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";;


  },

  getBatchesByBranchAndComapny2: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.batches +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";;


  },

  getSubjectsByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.subjects +
      "?domain=[('operating_branch_id', '='," + `${branch_id}` + "),('company_id', '='," + `${company_id}` + ")]";;


  },

  getSubjectsByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.subjects +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";;


  },

  getSubjectsByBranchAndComapny2: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.subjects +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";;


  },

  getAdmissionRegisterByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.admissions +
      "?domain=[('operating_branch_id', '='," + `${branch_id}` + "),('company_id', '='," + `${company_id}` + ")]";;


  },
  getAdmissionRegisterByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.admissions +
      "?domain=[('company_id', '='," + `${company_id}` + ")]";;


  },

  getTeachersByBranchAndComapny: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.teachers + "?branch_id=" + `${branch_id}&company_id=` + `${company_id}`;


  },
  getTeachersByBranchAndComapnyAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.teachers + "?company_id=" + `${company_id}`;


  },
  getTeachersByBranchAndComapny2: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.faculties + "?domain=[('company_id', '='," + `${company_id}` + ")]";


  },

  getStudentDetails: function (id, cbs, cbe) {
    const url = backendUrls.Others.student + "/" + `${id}`;


  },


  getCompanyDetailsBypartnerId: function (id, cbs, cbe) {
    const url = backendUrls.Others.companyYearByPartnerId + "/" + `${id}`;


  },

  getParents: function (branch_id, company_id, cbs, cbe) {
    const url = backendUrls.Others.allParent + "?branch_id=" + `${branch_id}&company_id=` + `${company_id}`;


  },

  getParentsAll: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.allParent + "?company_id=" + `${company_id}`;


  },


  getAcademyYear2: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.academicYearSearch + "?domain=[('company_id', '='," + `${company_id}` + ")]";


  },

  getCourseFees: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.courseFeesSearch + "?company_id=" + `${company_id}`;


  },

  getAdmissionRegisterByCourse: function (id, cbs, cbe) {
    const url = backendUrls.Others.admissionRegisterByCourse + "/" + `${id}`;


  },
  getAttendanceStudent: function (student_id, cbs, cbe) {
    const url = backendUrls.Others.getAttendanceStudent + "?student-id=" + `${student_id}`;


  },

  getExamCourse: function (student_id, course_id, cbs, cbe) {
    const url = backendUrls.Others.getExamCourse + "/" + `${student_id}` + "/" + `${course_id}`;


  },

  getApplicationAdmission: function (id, cbs, cbe) {
    const url = backendUrls.Others.applicationAdmission + "/" + `${id}`;


  },
  getOneAdmission: function (id, cbs, cbe) {
    const url = backendUrls.Others.oneAdmission + "/" + `${id}`;


  },

  getDetailsClassroom: function (id, cbs, cbe) {
    const url = backendUrls.Others.opClassroomsDetails + "/" + `${id}`;


  },

  getallClassroom: function (cbs, cbe) {
    const url = backendUrls.Others.opClassrooms;


  },

  getRestPartnerTitle: function (cbs, cbe) {
    const url = backendUrls.Others.resPartnerTitle;


  },

  getAdmissionCourse: function (id, cbs, cbe) {
    const url = backendUrls.Others.admissionCourse + "/" + `${id}`;


  },

  getAcademyTerm2: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.academicTermSearch + "?domain=[('company_id', '='," + `${company_id}` + ")]";


  },
  getOpFeesTerm: function (company_id, cbs, cbe) {
    const url = backendUrls.Others.opFeesTerm + "?domain=[('company_id', '='," + `${company_id}` + ")]";


  },

  getOpBatch: function (course_id, cbs, cbe) {
    const url = backendUrls.Others.opBatch + "?domain=[('course_id', '='," + `${course_id}` + ")]";


  },

  getSubjects: function (cbs, cbe) {
    const url = backendUrls.Others.subjects;


  },
  getFaculties: function (cbs, cbe) {
    const url = backendUrls.Others.faculties;


  },

  addAcademicYear: function (data, cbs, cbe) {
    const url = backendUrls.Others.academicYearAdd;


  },

  editAcademicYear: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.academicYearEdit + "/" + `${id}`;


  },
  addAcademicTerm: function (data, cbs, cbe) {
    const url = backendUrls.Others.academicTermAdd;


  },

  editAcademicTerm: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.academicTermEdit + "/" + `${id}`;


  },

  addFeesTerm: function (data, cbs, cbe) {
    const url = backendUrls.Others.feesCreate;


  },

  editFeesTerm: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.feesUpdate + "/" + `${id}`;


  },

  addCourse: function (data, cbs, cbe) {
    const url = backendUrls.Others.courseCreate;


  },

  addAdmissionAndAssignInClassroom: function (data, cbs, cbe) {
    const url = backendUrls.Others.createAdmissionAndAssignInClassroom;


  },


  addAddClassrooms: function (data, cbs, cbe) {
    const url = backendUrls.Others.opAddClassrooms;


  },

  editCourse: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.courseUpdate + "/" + `${id}`;


  },

  addBatch: function (data, cbs, cbe) {
    const url = backendUrls.Others.batchCreate;


  },

  editBatch: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.batchUpdate + "/" + `${id}`;


  },

  addSubject: function (data, cbs, cbe) {
    const url = backendUrls.Others.subjectCreate;


  },

  editSubject: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.subjectUpdate + "/" + `${id}`;


  },

  addAdmission: function (data, cbs, cbe) {
    const url = backendUrls.Others.admissionCreate;


  },

  editAdmission: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.admissionUpdate + "/" + `${id}`;


  },

  editClassroom: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.editClassroom + "/" + `${id}`;


  },

  addCourseFees: function (data, cbs, cbe) {
    const url = backendUrls.Others.courseFeesCreate;


  },

  editCourseFees: function (id, data, cbs, cbe) {
    const url = backendUrls.Others.courseFeesUpdate + "/" + `${id}`;


  },

  addTimetable: function (data, cbs, cbe) {
    const url = backendUrls.Others.addTimetable;


  },



  addStudent: function (data, cbs, cbe) {
    const url = backendUrls.Others.addStudent;


  },


  updateParent: function (data, cbs, cbe) {
    const url = backendUrls.Others.updateParent;


  },


};
export default UserService;
